import { Typography } from "@mui/material";
import React from "react";

import { Timer } from "../Timer";

interface IAuthErrorMessage {
  errorMessage?: string;
  localizedText: string;
  showTimer?: boolean;
}

export const AuthErrorMessage = ({ errorMessage, localizedText, showTimer }: IAuthErrorMessage) => {
  return (
    <Typography variant="caption1" sx={{ color: "#C61E00", fontSize: "12px", fontWeight: 400 }}>
      {localizedText}
      {!!showTimer && <Timer initialMinute={+(errorMessage?.match(/\d+/)?.[0] ?? 10)} initialSeconds={0} />}
    </Typography>
  );
};
